import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { JoinPromotionLog } from '@models/join-promotion';
import { create } from 'zustand';

const PAGE_SIZE = 20;

interface JoinPromotionLogsContainer {
  contents: JoinPromotionLog[];
  page: number;
  size: number;
  total: number;
  hasNext: boolean;
}

interface JoinPromotionLogsStoreProps {
  searchResultContainer: JoinPromotionLogsContainer;
  searchQuery: SearchPagenateQuery;
  searchKeyword?: string;
  setSearchKeyword: (keyword: string) => void;
  updateSearchQuery: (query: { [key: string]: any }) => void;
  resetSearchQuery: () => void;
  setJoinPromotionLogsContainer: (result: PagenatedResponse<JoinPromotionLog>) => void;
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;
}

export const useJoinPromotionLogsStore = create<JoinPromotionLogsStoreProps>((set) => ({
  searchResultContainer: {
    contents: [] as JoinPromotionLog[],
    total: 0,
    page: 0,
    size: 0,
    hasNext: false,
  },
  searchQuery: {
    page: 0,
    size: PAGE_SIZE,
    startDate: undefined,
    endDate: undefined,
  },
  searchKeyword: undefined,
  setStartDate: (date: string | null) => {
    set((state) => {
      return { ...state, searchQuery: { ...state.searchQuery, startDate: date } };
    });
  },
  setEndDate: (date: string | null) => {
    set((state) => {
      return { ...state, searchQuery: { ...state.searchQuery, endDate: date } };
    });
  },
  setJoinPromotionLogsContainer: (result) => {
    set((state) => {
      const contents = new Array(result.total || PAGE_SIZE);
      contents.splice(result.page * result.size, result.size, ...(result?.contents || []));
      const newValue = { ...state.searchResultContainer, ...result, contents: contents };
      return { ...state, searchResultContainer: newValue };
    });
  },
  setSearchKeyword: (keyword: string) => {
    set((state) => {
      return {
        ...state,
        searchKeyword: keyword,
        searchResultContainer: { ...state.searchResultContainer, size: 0 },
      };
    });
  },
  updateSearchQuery: (query: { [key: string]: any }) => {
    set((state) => {
      return {
        ...state,
        searchQuery: { ...state.searchQuery, ...query },
        searchResultContainer: { ...state.searchResultContainer, size: 0 },
      };
    });
  },
  resetSearchQuery: () => {
    set({
      searchQuery: {
        page: 0,
        size: PAGE_SIZE,
        type: 'all',
        startDate: undefined,
        endDate: undefined,
      },
    });
  },
}));
